import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Import ATS pages
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import Applicants from './Pages/Applicants';
import JobPosting from './Pages/JobPosting';
import PublishedJobs from './Pages/PublishedJobs';
import Submissions from './Pages/Submissions';
import InterviewSchedules from './Pages/InterviewSchedules';
import Placements from './Pages/Placements';
import Clients from './Pages/Clients';
import Vendors from './Pages/Vendors';
import TalentBench from './Pages/TalentBench';
import MessageCenter from './Pages/MessageCenter';
import EventCalendar from './Pages/EventCalendar';
import TaskManager from './Pages/TaskManager';
import Files from './Pages/Files';
import DownloadCenter from './Pages/DownloadCenter';
import AIAgents from './Pages/AIAgents';
import AdvancedSearch from './Pages/AdvancedSearch';
import Tools from './Pages/Tools';
import Groups from './Pages/Groups';
import FormTemplates from './Pages/FormTemplates';
import EBoarding from './Pages/EBoarding';
import Blacklist from './Pages/Blacklist';
import UnsubscribeList from './Pages/UnsubscribeList';
import ConsentDetails from './Pages/ConsentDetails';
import NotesList from './Pages/NotesList';
import ViewClipboard from './Pages/ViewClipboard';
import SnapList from './Pages/SnapList';
import SMSDashboard from './Pages/SMSDashboard';
import AddInterviewer from './Pages/AddInterviewer';
import ReleaseNotes from './Pages/ReleaseNotes';

export default function ATSApp() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/ats/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout currentPageName="Dashboard"><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/applicants" element={<ProtectedRoute><Layout currentPageName="Applicants"><Applicants /></Layout></ProtectedRoute>} />
      <Route path="/job-posting" element={<ProtectedRoute><Layout currentPageName="JobPosting"><JobPosting /></Layout></ProtectedRoute>} />
      <Route path="/published-jobs" element={<ProtectedRoute><Layout currentPageName="PublishedJobs"><PublishedJobs /></Layout></ProtectedRoute>} />
      <Route path="/submissions" element={<ProtectedRoute><Layout currentPageName="Submissions"><Submissions /></Layout></ProtectedRoute>} />
      <Route path="/interview-schedules" element={<ProtectedRoute><Layout currentPageName="InterviewSchedules"><InterviewSchedules /></Layout></ProtectedRoute>} />
      <Route path="/placements" element={<ProtectedRoute><Layout currentPageName="Placements"><Placements /></Layout></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute><Layout currentPageName="Clients"><Clients /></Layout></ProtectedRoute>} />
      <Route path="/vendors" element={<ProtectedRoute><Layout currentPageName="Vendors"><Vendors /></Layout></ProtectedRoute>} />
      <Route path="/talent-bench" element={<ProtectedRoute><Layout currentPageName="TalentBench"><TalentBench /></Layout></ProtectedRoute>} />
      <Route path="/message-center" element={<ProtectedRoute><Layout currentPageName="MessageCenter"><MessageCenter /></Layout></ProtectedRoute>} />
      <Route path="/event-calendar" element={<ProtectedRoute><Layout currentPageName="EventCalendar"><EventCalendar /></Layout></ProtectedRoute>} />
      <Route path="/task-manager" element={<ProtectedRoute><Layout currentPageName="TaskManager"><TaskManager /></Layout></ProtectedRoute>} />
      <Route path="/files" element={<ProtectedRoute><Layout currentPageName="Files"><Files /></Layout></ProtectedRoute>} />
      <Route path="/download-center" element={<ProtectedRoute><Layout currentPageName="DownloadCenter"><DownloadCenter /></Layout></ProtectedRoute>} />
      <Route path="/ai-agents" element={<ProtectedRoute><Layout currentPageName="AIAgents"><AIAgents /></Layout></ProtectedRoute>} />
      <Route path="/advanced-search" element={<ProtectedRoute><Layout currentPageName="AdvancedSearch"><AdvancedSearch /></Layout></ProtectedRoute>} />
      <Route path="/tools" element={<ProtectedRoute><Layout currentPageName="Tools"><Tools /></Layout></ProtectedRoute>} />
      <Route path="/groups" element={<ProtectedRoute><Layout currentPageName="Groups"><Groups /></Layout></ProtectedRoute>} />
      <Route path="/form-templates" element={<ProtectedRoute><Layout currentPageName="FormTemplates"><FormTemplates /></Layout></ProtectedRoute>} />
      <Route path="/e-boarding" element={<ProtectedRoute><Layout currentPageName="EBoarding"><EBoarding /></Layout></ProtectedRoute>} />
      <Route path="/blacklist" element={<ProtectedRoute><Layout currentPageName="Blacklist"><Blacklist /></Layout></ProtectedRoute>} />
      <Route path="/unsubscribe-list" element={<ProtectedRoute><Layout currentPageName="UnsubscribeList"><UnsubscribeList /></Layout></ProtectedRoute>} />
      <Route path="/consent-details" element={<ProtectedRoute><Layout currentPageName="ConsentDetails"><ConsentDetails /></Layout></ProtectedRoute>} />
      <Route path="/notes-list" element={<ProtectedRoute><Layout currentPageName="NotesList"><NotesList /></Layout></ProtectedRoute>} />
      <Route path="/view-clipboard" element={<ProtectedRoute><Layout currentPageName="ViewClipboard"><ViewClipboard /></Layout></ProtectedRoute>} />
      <Route path="/snap-list" element={<ProtectedRoute><Layout currentPageName="SnapList"><SnapList /></Layout></ProtectedRoute>} />
      <Route path="/sms-dashboard" element={<ProtectedRoute><Layout currentPageName="SMSDashboard"><SMSDashboard /></Layout></ProtectedRoute>} />
      <Route path="/add-interviewer" element={<ProtectedRoute><Layout currentPageName="AddInterviewer"><AddInterviewer /></Layout></ProtectedRoute>} />
      <Route path="/release-notes" element={<ProtectedRoute><Layout currentPageName="ReleaseNotes"><ReleaseNotes /></Layout></ProtectedRoute>} />
    </Routes>
  );
}
